// ============================================================
// 🔧 CHANGE THIS TO YOUR LEETCODE USERNAME
// ============================================================
export const LEETCODE_USERNAME = "Ratnakarsingh";

// Primary API — LIVE data, no in-memory cache
// Docs: https://github.com/tashifkhan/LeetCode-Stats-API
export const LEETCODE_API_BASE = "https://leetcode-stats.tashif.codes";

// Fallback — used only if primary fails (may be cached up to 5 min)
export const LEETCODE_FALLBACK_BASE = "https://alfa-leetcode-api.onrender.com";
